'use client'

import { createContext } from 'react'

export const GlobalContext = createContext({})
